// table.tsx

import { Table } from "../../../features/Table";
import { type L1Portfolio, porfolios_columns } from "./columns";
import { type FilterL1PortfoliosSchema, FilterL1Portfolios } from "./filter";

const client = "l1";
const table_name = "l1_portfolios";

export const L1PortfoliosTable = () => {
  return (
    <Table<L1Portfolio, FilterL1PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      columnVisibilityInit={{}}
      filter={<FilterL1Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
